import { useAuthStore } from "../../stores/auth-store";
import { useGlobalClient } from "../../hooks/use-global-client";
import { useClientService } from "../../hooks/use-client-service";
import { useEffect, useRef } from "react";

export function Header() {
  const { user, logout } = useAuthStore();
  const {
    selectedClient,
    isSuperAdmin,
    availableClients: clients,
    selectClient,
  } = useGlobalClient();

  const { loadClients, clientsLoading } = useClientService();
  const clientsLoadInitiated = useRef(false);

  // Load clients for super admin on mount
  useEffect(() => {
    if (
      isSuperAdmin &&
      clients.length === 0 &&
      !clientsLoading &&
      !clientsLoadInitiated.current
    ) {
      clientsLoadInitiated.current = true;
      loadClients(true);
    }
  }, [isSuperAdmin, clients.length, clientsLoading]); // Removed loadClients from dependencies to prevent infinite loop

  // Handle client selection change
  const handleClientChange = (clientId: string) => {
    selectClient(clientId);
  };

  return (
    <header className="bg-gray-900 shadow-lg border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-3">
            <img
              src="/img/activQMS.svg"
              alt="activQMS"
              className="h-8 w-auto"
            />
            <div className="hidden md:block">
              <span className="text-xs text-gray-400">
                Modular Conversation Platform
              </span>
            </div>

            {/* Client Selection for Super Admins */}
            {isSuperAdmin && (
              <div className="ml-4">
                <label
                  htmlFor="client-select"
                  className="text-xs text-gray-300 mr-2"
                >
                  Client:
                </label>
                <select
                  id="client-select"
                  className="bg-gray-800 text-gray-200 px-2 py-1 rounded text-xs border border-gray-700 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  value={selectedClient?.id || ""}
                  onChange={(e) => handleClientChange(e.target.value)}
                  disabled={clientsLoading}
                  data-testid="header-client-select"
                >
                  <option value="">
                    {clientsLoading ? "Loading..." : "Select Client"}
                  </option>
                  {clients.map((client) => (
                    <option key={client.id} value={client.id}>
                      {client.clientName}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>

          <div className="flex items-center space-x-4">
            {user && (
              <>
                <span className="text-sm text-gray-300">
                  Welcome, {user.firstName} {user.lastName}
                </span>
                <button
                  onClick={logout}
                  className="bg-brand-600 hover:bg-brand-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200"
                >
                  Sign Out
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
